import registerForRails from 'js/utils/registerForRails';
import Search from 'js/search/react/Search';
import SearchOnboardingOverhaul from 'js/search/react/SearchOnboardingOverhaul';

registerForRails({
  Search,
  SearchOnboardingOverhaul,
});
